var isUUID4Hex = function isUUID4Hex(s) {
  //case insensitive 32-char match ("ABCD1234...")
  var regexExpHex = new RegExp("^[a-f0-9]{12}4[a-f0-9]{3}[89ab][a-f0-9]{15}$", "i");
  return s && regexExpHex.test(s);
};
var isUUID4Str = function isUUID4Str(s) {
  //case insensitive 36-char match with hyphens ("ABCD1234-AB12-4...")
  var regexExpUUID = new RegExp("^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$", "i");
  return s && regexExpUUID.test(s);
};
var isUUID4 = function isUUID4(s) {
  return isUUID4Hex(s) || isUUID4Str(s);
};
export { isUUID4, isUUID4Hex, isUUID4Str };